import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import VueVirtualScroller from 'vue-virtual-scroller'

import type { UserModule } from '~/types'

/**
 * Registers the scroller components globally. Every current consumer imports them
 * directly instead (Storybook does not install `src/modules/*`, so they have to), but
 * the plugin stays as the app-level install path.
 *
 * The `itemsLimit` option this used to pass is gone from v3's `PluginOptions`; the limit
 * now travels as an `items-limit` prop on each scroller — see
 * `VIRTUAL_SCROLLER_ITEMS_LIMIT` in `~/constants`.
 */
export const install: UserModule = ({ app }) => {
  app.use(VueVirtualScroller)
}
